var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import Cover from "../Components/Cover.vue";
import AlertList from "../Components/AlertList.vue";
import Row from "bootstrap-vue/es/components/layout/row";
import Col from "bootstrap-vue/es/components/layout/col";
import Card from "../Components/Card.vue";
import CardGroup from "bootstrap-vue/es/components/card/card-group";
import Coordinators from "../Components/Coordinators.vue";
import Rate from "../Components/Rate.vue";
import BingMap from "../Components/BingMap.vue";
import BreadcrumbAnchor from "../Components/BreadcrumbAnchor.vue";
import Register from "../Components/Register.vue";
var WinterCourseYear = /** @class */ (function (_super) {
    __extends(WinterCourseYear, _super);
    function WinterCourseYear() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ type: Object })
    ], WinterCourseYear.prototype, "general", void 0);
    __decorate([
        Prop({ type: Object })
    ], WinterCourseYear.prototype, "banner", void 0);
    __decorate([
        Prop({ type: Object })
    ], WinterCourseYear.prototype, "socialMedia", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], WinterCourseYear.prototype, "information", void 0);
    __decorate([
        Prop({ type: Object })
    ], WinterCourseYear.prototype, "universityCredit", void 0);
    __decorate([
        Prop({ type: Object })
    ], WinterCourseYear.prototype, "tuition", void 0);
    __decorate([
        Prop({ type: String })
    ], WinterCourseYear.prototype, "generalEmail", void 0);
    __decorate([
        Prop({ type: String })
    ], WinterCourseYear.prototype, "generalPhoneNumber", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], WinterCourseYear.prototype, "courses", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], WinterCourseYear.prototype, "registerUrl", void 0);
    __decorate([
        Prop({ type: String })
    ], WinterCourseYear.prototype, "registrationUrl", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], WinterCourseYear.prototype, "registered", void 0);
    __decorate([
        Prop({ type: String })
    ], WinterCourseYear.prototype, "registrationStart", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], WinterCourseYear.prototype, "resources", void 0);
    WinterCourseYear = __decorate([
        Component({
            name: "WinterCourseYear",
            components: {
                Cover: Cover,
                AlertList: AlertList,
                "b-card-group": CardGroup,
                Card: Card,
                Coordinators: Coordinators,
                Rate: Rate,
                BingMap: BingMap,
                BreadcrumbAnchor: BreadcrumbAnchor,
                Register: Register,
                "b-row": Row,
                "b-col": Col
            }
        })
    ], WinterCourseYear);
    return WinterCourseYear;
}(Vue));
export default WinterCourseYear;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/WinterCourseYear/WinterCourseYear.vue
// module id = 910
// module chunks = 5